module.exports = __webpack_public_path__ + "img/upload_white_arrow.89bae866.svg";